import classNames from "classnames";
import React, { useEffect } from "react";

import IconClose from "assets/icons/Close";
import Button from "../Button";
import styles from "./styles.module.scss";

interface Props {
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  footer?: React.ReactNode;
  footerClassName?: string;
  onClose?: () => void;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  subtitle?: React.ReactNode;
  title?: string;
  visible?: boolean;
}

const Modal: React.FC<Props> = ({
  children,
  className,
  contentClassName,
  footer,
  footerClassName,
  onClose,
  onSubmit,
  subtitle,
  title,
  visible,
}) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
      document.body.setAttribute("data-lenis-prevent", "true");
    } else {
      document.body.style.overflow = "auto";
      document.body.removeAttribute("data-lenis-prevent");
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.removeAttribute("data-lenis-prevent");
    };
  }, [visible]);

  return (
    <>
      <div
        className={classNames(styles.overlay, visible && styles.visible)}
        onClick={onClose}
        onKeyDown={() => null}
        role="grid"
        tabIndex={0}
      />

      {visible && (
        <div className={styles.container}>
          <form
            className={classNames(styles.modal, className)}
            onSubmit={onSubmit}
          >
            <div className={styles.header}>
              <div
                className={classNames(
                  styles.titleContainer,
                  title && styles.title
                )}
              >
                {title && <div className={styles.title}>{title}</div>}

                <Button className={styles.button} onClick={onClose}>
                  <IconClose className={styles.icon} />
                </Button>
              </div>

              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </div>

            <div className={classNames(styles.content, contentClassName)}>
              {children}
            </div>

            {footer && (
              <div className={classNames(styles.footer, footerClassName)}>
                {footer}
              </div>
            )}
          </form>
        </div>
      )}
    </>
  );
};

export default Modal;
